/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnedisConnectionConfig } from '../../models/enedis-connection-config';

export interface GetEnedisConnectionConfigurations$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected enedis connection configuration
 */
  enedisUid: string;
}

export function getEnedisConnectionConfigurations(http: HttpClient, rootUrl: string, params: GetEnedisConnectionConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<EnedisConnectionConfig>> {
  const rb = new RequestBuilder(rootUrl, getEnedisConnectionConfigurations.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('enedisUid', params.enedisUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnedisConnectionConfig>;
    })
  );
}

getEnedisConnectionConfigurations.PATH = '/stations/{uid}/enedis/{enedisUid}';
